import React from "react";
import { GetStaticProps, NextPage } from "next";
import dynamic from "next/dynamic";
import { FrontAuthProps, withFrontAuth } from "lib/hoc/withFrontAuth";
import Main from "components/front/layout/Main";
import RootSection from "components/front/layout/RootSection";
import GeneralHead from "../components/front/head/GeneralHead";
import { Header } from "components/front/layout/Header";
import { Props as FooterProps } from "../components/front/layout/Footer";
import { Props as GeneralFootProps } from "components/front/layout/GeneralFoot";
import { Props as TermSectionProps } from "components/front/term/TermSection";

const TermSection = dynamic<TermSectionProps>(() => import("components/front/term/TermSection"));
const Footer = dynamic<FooterProps>(() => import("components/front/layout/Footer"));
const GeneralFoot = dynamic<GeneralFootProps>(() => import("components/front/layout/GeneralFoot").then((m) => m.GeneralFoot));

type Props = Record<string, never>;
const TermPage: NextPage<Props & FrontAuthProps> = () => (
  <>
    <GeneralHead screenName={"利用規約"} />
    <Header />
    <Main>
      <RootSection>
        <TermSection />
      </RootSection>
    </Main>
    <Footer />
    <GeneralFoot />
  </>
);
export const getStaticProps: GetStaticProps<Props> = async () => {
  return {
    props: {},
  };
};
export default withFrontAuth(TermPage);
